module.exports = ".dropdown-item:focus, .dropdown-item:hover {\n  color: #ffffff !important;\n  text-decoration: none;\n  background-color: #d8250d;\n}\n\n.dropdown-item:hover {\n  cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/menu/menu.component.css
// module id = ./src/app/components/menu/menu.component.css
// module chunks = main